import { useState } from "react";
import { SectionLabel } from "@/components/common";
import { useFetch } from "@/lib/api";
import { cn } from "@/lib/utils";
import { Attribution, QuoteMark, REL_META } from "./parts";

const FILTERS = [["ALL", "All"], ...Object.entries(REL_META).map(([k, m]) => [k, m.plural])];

export const TestimonialsBrowser = ({ number = "04" }) => {
  const { data } = useFetch("/testimonials");
  const [filter, setFilter] = useState("ALL");
  const all = data || [];
  if (!all.length) return null;
  const shown = filter === "ALL" ? all : all.filter((t) => t.relationship === filter);
  return (
    <section className="container-x pb-24 md:pb-32" data-testid="about-testimonials" aria-labelledby="about-testimonials-title">
      <SectionLabel number={number}>Kind Words</SectionLabel>
      <div className="mt-6 flex flex-wrap items-end justify-between gap-6">
        <h2 id="about-testimonials-title" className="max-w-2xl font-display text-4xl leading-[1] md:text-5xl">From clients, colleagues & collaborators.</h2>
        <div className="flex flex-wrap gap-2" role="group" aria-label="Filter testimonials" data-testid="testimonials-filter">
          {FILTERS.map(([k, label]) => (
            <button key={k} type="button" aria-pressed={filter === k} onClick={() => setFilter(k)} data-testid={`testimonials-filter-${k.toLowerCase()}`} className={cn("rounded-full border px-4 py-2 text-xs transition-colors", filter === k ? "border-turq bg-turq text-onturq" : "border-line/20 text-silver hover:border-turq hover:text-fg")}>
              {label}
            </button>
          ))}
        </div>
      </div>
      {shown.length === 0 ? (
        <p className="mt-12 rounded-md border border-dashed border-line/20 p-10 text-center text-sm text-silver" data-testid="testimonials-filter-empty">No testimonials in this category yet.</p>
      ) : (
        <div className="mt-12 grid gap-px overflow-hidden rounded-md border border-line/10 bg-line/10 md:grid-cols-2" data-testid="about-testimonials-list">
          {shown.map((t) => (
            <figure key={t.id} className="flex flex-col justify-between gap-8 bg-canvas p-8 md:p-12" data-testid={`about-testimonial-${t.id}`}>
              <blockquote>
                <QuoteMark className="text-[4.5rem]" />
                <p className="font-display text-2xl leading-snug md:text-[1.7rem]">{t.quote}</p>
              </blockquote>
              <Attribution t={t} size="h-12 w-12" />
            </figure>
          ))}
        </div>
      )}
    </section>
  );
};
